<template>
  <div class="flex-grow flex flex-col w-full h-full relative">
    <!-- Auto-save status indicator -->
    <div class="px-4 py-2 text-xs flex items-center justify-end border-b border-gray-200">
      <span v-if="saveStatus === 'saving'" class="flex items-center text-gray-500">
        <svg
          class="animate-spin h-3 w-3 mr-1"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        Saving...
      </span>
      <span v-else-if="saveStatus === 'saved'" class="flex items-center text-green-600">
        <CheckIcon class="h-3 w-3 mr-1" />
        Saved at {{ formatTime(lastSaved) }}
      </span>
      <span v-else-if="saveStatus === 'error'" class="flex items-center text-red-600">
        <ExclamationIcon class="h-3 w-3 mr-1" />
        Save failed
      </span>
    </div>

    <!-- Scrollable reflection cards area -->
    <div class="overflow-y-auto h-full flex-1 px-4 pb-4 space-y-4 pt-4">
      <WhatCard
        :initialValue="reflectionData.what"
        @fieldChanged="handleFieldChanged"
        :inSession="true"
      />
    </div>
  </div>
</template>

<script>
import { CheckIcon, ExclamationIcon } from '@heroicons/vue/solid';
import _debounce from 'lodash/debounce';
import WhatCard from '@/Pages/User/Reflection/WhatCard.vue';

export default {
  name: 'ReflectionLayout',
  components: { WhatCard, CheckIcon, ExclamationIcon },
  data() {
    return {
      reflectionData: {
        what: this.$page.props.session.reflection?.what || null,
        so_what: this.$page.props.session.reflection?.so_what || null,
        now_what: this.$page.props.session.reflection?.now_what || null,
      },
      isSaving: false,
      saveStatus: null, // 'saving', 'saved', 'error'
      lastSaved: null,
    };
  },
  created() {
    // Create debounced save function (1 second delay)
    this.debouncedSave = _debounce(this.saveReflection, 1000);
  },
  methods: {
    handleFieldChanged(data) {
      // Update local data
      this.reflectionData[data.field] = data.value;
      // Trigger debounced save
      this.debouncedSave();
    },
    async saveReflection() {
      this.isSaving = true;
      this.saveStatus = 'saving';
      try {
        await axios.post(route('reflection.update'), {
          what: this.reflectionData.what,
          session_id: this.$page.props.session.id,
        });
        this.saveStatus = 'saved';
        this.lastSaved = new Date();
        // Hide success message after 2 seconds
        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      } catch (error) {
        console.error('Auto-save failed:', error);
        this.saveStatus = 'error';
      } finally {
        this.isSaving = false;
      }
    },
    formatTime(date) {
      if (!date) return '';
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped></style>
